export default {
  LOGIN: "LOGIN",
  SIGNUP: "SIGNUP",
  IS_LOGGEDIN: "IS_LOGGED_IN",
  SET_ACCOUNT_FIELD: "SET_ACCOUNT_FIELDS",
  SET_HOME_FIELD: "SET_HOME_FIELD",
  SET_USERS: "SET_USERS",
};
